import * as React from "react";

import "./apm-prefs-panel.scss";

import {cs} from "@Common/react/chain-services";

import {AdditionalOptionsPanel}      from "./additional-options-panel/additional-options-panel";
import {DefaultRadiusListQuantities} from "./default-radius-list-quantities/default-radius-list-quantities";
import {TemplateList}                from "./template-list/template-list";

export const ApmPrefsPanel = (
    {
        productLabel, product, styleTemplates, programPrefs, store, mailingLists, quantities, mailing,
        defaultUrl, coating,
    }
) => cs(
    ({}) => (
        <div className="apm-prefs-panel apm-prefs-panel-6zc">
            {TemplateList({
                className: "section",
                productLabel,
                product,
                styleTemplates,
                programPrefs, store,
            })}
            {quantities && DefaultRadiusListQuantities({
                className: "section",
                programPrefs,
                product,
                mailing,
                store,
            })}
            {AdditionalOptionsPanel({
                className: "section",
                programPrefs,
                product,
                store,
                mailing,
                mailingLists,
                coating,
                defaultUrl,
            })}
        </div>
    ),
);
